const firebaseConfig = {
    apiKey: "AIzaSyDSWXK5nehaJ3jfBvh-vBA5Xxwy0eIovDQ",
    authDomain: "crypto-feed-7ab1c.firebaseapp.com",
    projectId: "crypto-feed-7ab1c",
    storageBucket: "crypto-feed-7ab1c.appspot.com",
    messagingSenderId: "927851725226",
    appId: "1:927851725226:web:01c368ec690d54006cabd3",
    measurementId: "G-27VG5KP7LL"
  };

  export default firebaseConfig;